import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';
import {IniciarRedacaoCommand, RedacaoResumido, SalvarFotoCommand, SalvarRedacaoCommand} from '@app/models/redacao';
import { RetornoPadrao } from '@app/models/sisrh.model';

@Injectable({
  providedIn: 'root'
})
export class RedacaoService {

  constructor(private http: HttpClient) {
  }

  iniciarRedacao(command: IniciarRedacaoCommand): Observable<RetornoPadrao> {
    return this.http.post<RetornoPadrao>(`${environment.url_api_sisrh}/v1/redacao/iniciar`, command);
  }

  buscarRedacaoResumido(idRedacao: string, idVaga: string): Observable<RedacaoResumido> {
    return this.http.get<RedacaoResumido>(`${environment.url_api_sisrh}/v1/redacao/buscar-resumido/${idVaga}/${idRedacao}`);
  }

  salvarRedacao(command: SalvarRedacaoCommand): Observable<RetornoPadrao> {
    return this.http.post<RetornoPadrao>(`${environment.url_api_sisrh}/v1/redacao/`, command);
  }

  salvarFoto(command: SalvarFotoCommand): Observable<RetornoPadrao> {
    return this.http.post<RetornoPadrao>(`${environment.url_api_sisrh}/v1/redacao/foto`, command);
  }

  verificarToken(token: any): Promise<any> {
    return this.http.get<any>(`${environment.url_api_sisrh}/v1/redacao/verificar-token/${token}`).toPromise();
  }
}
